import { Box, Button, Grid, IconButton } from "@mui/material";
import CustomInput from "../components/ui/CustomInput";
import PageHeader from "../components/ui/PageHeader";
import PageForm from "../components/ui/PageForm";
import BarcodeIcon from "../components/ui/BarcodeIcon";
import CustomGridCell from "../components/ui/CustomGridCell";
import CustomGridHeaderCell from "../components/ui/CustomGridHeaderCell";
import { useRef, useState, useEffect } from "react";
import CustomTable from "../components/ui/CustomTable";
import axios from "../api/axiosClient";
import CustomTablePagingInfo from "../components/ui/CustomTablePagingInfo";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import { useSelector } from "react-redux";
import {
  handleError,
  errorToast,
  useKeyDown,
  addDownloadLinkToDocument,
} from "../services/serviceBase";
import toast from "react-hot-toast";
import DownloadIcon from "@mui/icons-material/Download";
import * as apiService from "../services/apiService";

const TKDashboard = () => {
  const intl = useIntl();
  const idCompany = useSelector((state) => state.common.company);

  const { setLoading } = useLoading();

  const [returnAuthorizationKey, setReturnAuthorizationKey] = useState("");
  const [cartonBarcode, setCartonBarcode] = useState("");
  const [year, setYear] = useState("");
  const [raDepartment, setRaDepartment] = useState({ text: "", value: "" });
  const [tkType, setTkType] = useState({ text: "", value: "" });
  const [raNumber, setRaNumber] = useState("");
  const [raSplit, setRaSplit] = useState("");
  const [type, setType] = useState("");
  const [sku, setSKU] = useState("");
  const [cartonQC, setCartonQC] = useState("");
  
  const [jdaIct, setJdaIct] = useState("");
  const [outcome, setOutcome] = useState("");
  const [sapInboundDelivery, setSapInboundDelivery] = useState("");
  const [sapRso, setSapRso] = useState("");
  const [invoice, setInvoice] = useState("");
  const [sapClient, setSapClient] = useState("");  
  const [stealthClient, setStealthClient] = useState("");
  const [clientDescription, setClientDescription] = useState("");
  const [shopCode, setShopCode] = useState("");
  const [jdaLocation, setJdaLocation] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [shouldFilterCollapse, setShouldFilterCollapse] = useState(false);

  const tkTypes = [
    {
      value: "TK02",
      text: "TK02",
    },
    {
      value: "TK03",
      text: "TK03",
    },
    {
      value: "TK09",
      text: "TK09",
    },
    {
      value: "TK32",
      text: "TK32",
    },
    {
      value: "TK02E",
      text: "TK02E",
    },
    {
      value: "TK03E",
      text: "TK03E",
    },
  ];

  const [departments, setDepartments] = useState([]);
  const [types, setTypes] = useState([]);

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setColumns] = useState([]);

  const [tableHeigth, setTableHeigth] = useState(260);

  const handleDatesValidation = () => {
    if (fromDate != null && toDate != null && fromDate > toDate) {
      setFromDate(null);
      setToDate(null);
      toast.error(
        intl.formatMessage({ id: "Error.StartDateLaterThenEndDate" })
      );
    } else if (fromDate != null) {
      setFromDate(fromDate);
    } else if (toDate != null) {
      setToDate(toDate);
    }
  };

  useEffect(() => {
    handleDatesValidation();
  }, [fromDate, toDate]);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 10;

  const actAsCustomerCode = useSelector((state) => state.actas.customerCode);

  useKeyDown(() => {
    handleSearch();
  }, ["Enter"]);

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var headerHeight = document.querySelector("#header").clientHeight;
    var pagingInfoHeight = document.querySelector("#pagingInfo").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight =
      pageHeight - fromHeight - headerHeight - pagingInfoHeight - 90;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);
  
  useEffect(() => {
    getColumns();
  }, [rows, page, tableHeigth]);

  const handleReprocess = (idTkImportFile, tkFileType) => {
    setLoading(true);
    var url = "/tkdata/" + idTkImportFile + "/reprocess";
    const params = new URLSearchParams([]);
    params.append("tkType", tkFileType);
    url += "?" + params.toString();
    axios
      .post(url)
      .then((response) => {
        setLoading(false);
        toast.success(
          intl.formatMessage({ id: "TkInfo.ReProcessRequestSent" })
        );
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleDownload = (idTkImportFile, tkFileType) => {
    setLoading(true);
    var url = "/tkdata/" + idTkImportFile + "/json";
    const params = new URLSearchParams([]);
    params.append("tkType", tkFileType);
    url += "?" + params.toString();
    axios
      .post(url)
      .then((response) => {
        let fileName = "1.tmp";
        const contentDisposition = response.headers["content-disposition"];

        if (contentDisposition) {
          const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
          const matches = asciiFilenameRegex.exec(contentDisposition);
          if (matches != null && matches[2]) {
            fileName = matches[2];
          }
        }
        const contentType = response.headers["content-type"];
        const blob = response.data;
        var file = new File([blob], fileName, { type: contentType });
        downloadJSON(blob, fileName);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const downloadJSON = (data, filename) => {
    const jsonData = new Blob([JSON.stringify(data)], {
      type: "application/json",
    });
    const jsonURL = URL.createObjectURL(jsonData);
    const link = document.createElement("a");
    link.href = jsonURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getColumns = () => {
    setColumns([
      {
        field: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.Action" })}
          />
        ),
        minWidth: 150,
        resizable: false,
        renderCell: (params) => {
          if (
            params.row.status !== "Imported" &&
            params.row.status !== "SentToAPE"
          ) {
            return (
              <Button
                disableRipple={true}
                onClick={(e) => handleReprocess(params.row.idTK, params.row.tkType)}
              >
                {intl.formatMessage({ id: "TkInfo.ReProcess" })}
              </Button>
            );
          }
        },
      },
      {
        field: "actions2",
        type: "actions2",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.Download" })}
          />
        ),
        minWidth: 90,
        resizable: false,
        renderCell: (params) => {
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(e) => { handleDownload(params.row.idTK, params.row.tkType); }}
            >
              <DownloadIcon />
            </IconButton>
          );
        },
      },
      {
        field: "returnFileKey",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell item1={intl.formatMessage({ id: "RA.Key" })} />
        ),
        flex: 1,
        minWidth: 250,
      },
      {
        field: "tkType",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "TkInfo.TKType" })}
          />
        ),
        flex: 1,
        minWidth: 90,
      },
      {
        field: "status",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.Status" })}
          />
        ),
        flex: 1,
        minWidth: 90,
      },
      {
        field: "errorMessage",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "TkInfo.ErrorMessage" })}
          />
        ),
        flex: 1,
        minWidth: 500,
      },
      {
        field: "ictReference",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RA.Invoice" })}
            item2={intl.formatMessage({ id: "RASearch.JDAICT" })}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.invoiceNumber}
              item2={params.row.ictReference}
            />
          );
        },
      },
      {
        field: "sapInboundDelivery",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RA.SapInboundDelivery" })}
            item2={intl.formatMessage({ id: "RASearch.SAPRSO" })}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 160,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.docNumber}
              item2={params.row.saprso}
            />
          );
        },
      },
      {
        field: "customerDescription",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.ClientDescription" })}
            item2={intl.formatMessage({ id: "RA.SAPClient" })}
            item3={intl.formatMessage({ id: "RA.STEALTHClient" })}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={
                params.row.shopDescription != null
                  ? params.row.shopDescription
                  : params.row.customerDescription
              }
              item2={params.row.customerCode}
              item3={
                params.row.stealthShopCode != null
                  ? params.row.stealthShopCode
                  : params.row.stealthCustomerCode
              }
            />
          );
        },
      },
      {
        field: "sapSender",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RASearch.SAPSender" })}
            item2={intl.formatMessage({ id: "RASearch.JDASender" })}
            item3={intl.formatMessage({ id: "RASearch.SenderDescription" })}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.shopCode}
              item2={params.row.jdaLocation}
              item3={params.row.shopDescription}
            />
          );
        },
      },
    ]);
  };

  const getDepartments = async () => {
    apiService.getDepartments(
      (response) => {
        setLoading(false);
        var selectDepartmentItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectDepartmentItems.push({
              value: x.departmentCode,
              text: x.departmentCode + " - " + x.departmentName,
            });
          });
        }
        setDepartments(selectDepartmentItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  useState(() => {
    getDepartments();
  }, []);

  const getTypes = async () => {
    setLoading(true);
    axios
      .get("/masterdata/ReturnFileTypes")
      .then((response) => {
        setLoading(false);
        var selectTypeItems = [];
        if (response.data !== undefined) {
          response.data
            .sort((a, b) =>
              a.returnDescription > b.returnDescription ? 1 : -1
            )
            .map((x) => {
              selectTypeItems.push({
                value: x.idReturnType,
                text: x.returnDescription,
              });
            });
        }
        setTypes(selectTypeItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useState(() => {
    getTypes();
  }, []);

  const handleSearchClick = () => {
    page.current = 0;
    handleSearch();
  };

  const handleSearch = () => {
    setShouldFilterCollapse(false);
    setLoading(true);
    const params = new URLSearchParams([]);

    params.append("IdCompany", idCompany);
    if (returnAuthorizationKey !== "") {
      params.append("ReturnFileKey", `${returnAuthorizationKey}`);
    }
    if (cartonBarcode !== "") {
      params.append("BoxBarcode", `${cartonBarcode}`);
    }
    if (sku !== "") {
      params.append("SKU", `${sku}`);
    }
    if (cartonQC !== "") {
      params.append("QCCarton", `${cartonQC}`);
    }
    if (year !== undefined) {
      params.append("RFYear", `${year}`);
    }
    if (
      raDepartment != null &&
      raDepartment.text !== undefined &&
      raDepartment.text !== ""
    ) {
      params.append("Department", `${raDepartment.value}`);
    }
    if (raNumber !== "") {
      params.append("RFNumber", `${raNumber}`);
    }
    if (raSplit !== "") {
      params.append("RFSplit", `${raSplit}`);
    }

    if (jdaIct !== "") {
      params.append("ICTReference", `${jdaIct}`);
    }
    if (outcome!== "") {
      params.append("Outcome", `${outcome}`);
    }
    if (sapRso !== "") {
      params.append("SAPRSO", `${sapRso}`);
    }
    if (
      sapInboundDelivery !== ""
    ) {
      params.append(
        "SAPInboundDelivery",
        `${sapInboundDelivery}`
      );
    }
    if (invoice !== "") {
      params.append("InvoiceNumber", `${invoice}`);
    }

    if (
      actAsCustomerCode !== undefined &&
      actAsCustomerCode !== "" &&
      actAsCustomerCode !== null
    ) {
      params.append("CustomerCode", `${actAsCustomerCode}`);
    } else if (
      sapClient !== ""
    ) {
      params.append("CustomerCode", `${sapClient}`);
    }

    if (
      clientDescription !== ""
    ) {
      params.append(
        "CustomerOrShopDescr",
        `${clientDescription}`
      );
    }

    if (
      stealthClient !== ""
    ) {
      params.append(
        "StealthClientOrShopCode",
        `${stealthClient}`
      );
    }

    if (type !== undefined && type !== "") {
      params.append("IdRFType", `${type}`);
    }

    if (
      jdaLocation !== ""
    ) {
      params.append("JdaLocation", `${jdaLocation}`);
    }

    if (shopCode !== "") {
      params.append("ShopCode", `${shopCode}`);
    }

    if (tkType != null && tkType.text !== undefined && tkType.text !== "") {
      params.append("TKType", `${tkType.value}`);
    }

    if (fromDate !== undefined && fromDate !== "" && fromDate !== null) {
      var date = fromDate.toISOString().substring(0, 10);
      params.append("FromDate", date);
    }

    if (toDate !== undefined && toDate !== "" && toDate !== null) {
      var date = toDate.toISOString().substring(0, 10);
      params.append("ToDate", date);
    }

    if (page.current === 0) {
      page.current = 1;
    }
    params.append("PagingInfo.Skip", `${rowsForPage * (page.current - 1)}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);
    axios
      .get("/tkdata", { params })
      .then((response) => {
        setShouldFilterCollapse(true);
        setLoading(false);
        resizeTable();

        var data = [];
        response.data.paginatedItems.map((x) => {
          var item = x;
          item.tkDashboardId = x.idTK + "-" + x.docNumber + "-" + x.tkType;
          data.push(item);
        });

        setRows(data);
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleReset = () => {
    setReturnAuthorizationKey("");
    setCartonBarcode("");
    setYear("");
    setRaDepartment({ text: "", value: "" });
    setTkType({ text: "", value: "" });
    setRaNumber("");
    setRaSplit("");
    setFromDate(null);
    setToDate(null);
    setType("");
    setSKU("");
    setCartonQC("");
    setJdaIct("");
    setSapInboundDelivery("");
    setInvoice("");
    setSapRso("");

    if (
      actAsCustomerCode == null ||
      actAsCustomerCode == undefined ||
      actAsCustomerCode == ""
    ) {
      setSapClient("");
    }

    setStealthClient("");
    setClientDescription("");
    setJdaLocation("");
    setShopCode("");
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearch();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 1) {
      page.current = page.current - 1;
      handleSearch();
    }
  };

  const handletrasitionEnd = () => {
    resizeTable();
  };

  const handleRaKeyChange = (barcode) => {
    setReturnAuthorizationKey(barcode);
  };

  const handleCartonBarcodeChange = (barcode) => {
    setCartonBarcode(barcode);
  };

  const handleSKUChange = (sku) => {
    if (sku !== undefined && sku !== "") {
      setSKU(sku);
    } else {
      setSKU("");
    }
  };

  const handleCartonQCChange = (cartonQC) => {
    if (cartonQC !== undefined && cartonQC !== "") {
      setCartonQC(cartonQC);
    } else {
      setCartonQC("");
    }
  };

  const handleYearChange = (year) => {
    if (year !== undefined && year !== "") {
      setYear(year);
    } else {
      setYear("");
    }
  };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader title={intl.formatMessage({ id: "TkDashboard.Title" })} />
      <PageForm
        adjustHeightFunc={handletrasitionEnd}
        shouldCollapse={shouldFilterCollapse}
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Grid container>
                  <Grid item md={12}>
                    <CustomInput
                      name="RAKey"
                      labelText={intl.formatMessage({ id: "RA.Key" })}
                      type="text"
                      value={returnAuthorizationKey}
                      setValue={(e) => handleRaKeyChange(e)}
                      iconComponent={BarcodeIcon}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      name="CartonBarcode"
                      labelText={intl.formatMessage({
                        id: "RASearch.CartonBarcode",
                      })}
                      type="text"
                      value={cartonBarcode}
                      setValue={(e) => {
                        handleCartonBarcodeChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      name="SKU"
                      labelText={intl.formatMessage({
                        id: "RASearch.SKU",
                      })}
                      type="text"
                      value={sku}
                      setValue={(e) => {
                        handleSKUChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      name="cartonQC"
                      labelText={intl.formatMessage({
                        id: "RASearch.CartonQC",
                      })}
                      type="text"
                      value={cartonQC}
                      setValue={(e) => {
                        handleCartonQCChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={6}
                      inputCol={6}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RASearch.Outcome" })}
                      type="text"
                      value={outcome}
                      setValue={setOutcome}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={9.6}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Year" })}
                      type="number"
                      value={year}
                      setValue={(e) => {
                        handleYearChange(e);
                      }}
                      textCol={3.8}
                      inputCol={8.2}
                    />
                  </Grid>
                  <Grid item md={1.2}>
                    <Button
                      value={new Date().getFullYear() - 1}
                      onClick={(e) => {
                        handleYearChange(e.target.value);
                      }}
                      disableRipple={true}
                      sx={{ marginTop: "10px" }}
                    >
                      {new Date().getFullYear() - 1}
                    </Button>
                  </Grid>
                  <Grid item md={1.2}>
                    <Button
                      value={new Date().getFullYear()}
                      onClick={(e) => {
                        handleYearChange(e.target.value);
                      }}
                      disableRipple={true}
                      sx={{ marginTop: "10px" }}
                    >
                      {new Date().getFullYear()}
                    </Button>
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Department" })}
                      type="autocomplete"
                      value={raDepartment}
                      selectItems={departments}
                      setValue={setRaDepartment}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Number" })}
                      type="number"
                      value={raNumber}
                      setValue={setRaNumber}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Split" })}
                      type="number"
                      value={raSplit}
                      setValue={setRaSplit}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "TkInfo.TKType" })}
                      type="autocomplete"
                      value={tkType}
                      selectItems={tkTypes}
                      setValue={setTkType}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.ICT" })}
                      type="text"
                      value={jdaIct}
                      setValue={setJdaIct}
                      textCol={6}
                      inputCol={6}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Invoice" })}
                      type="text"
                      value={invoice}
                      setValue={setInvoice}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RA.SapInboundDelivery",
                      })}
                      type="text"
                      value={sapInboundDelivery}
                      setValue={setSapInboundDelivery}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.SAPRSO",
                      })}
                      type="text"
                      value={sapRso}
                      setValue={setSapRso}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "General.SapClientCode",
                      })}
                      type="text"
                      value={sapClient}
                      setValue={setSapClient}
                      defaultValue={actAsCustomerCode}
                      disabled={actAsCustomerCode != null}
                      textCol={6}
                      inputCol={6}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "General.StealthClientCode",
                      })}
                      type="text"
                      value={stealthClient}
                      setValue={setStealthClient}
                      textCol={7.5}
                      inputCol={4.5}
                    />
                  </Grid>
                  <Grid item md={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "General.ClientDescription",
                      })}
                      type="text"
                      value={clientDescription}
                      setValue={setClientDescription}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.SAPLocation",
                      })}
                      type="text"
                      value={shopCode}
                      setValue={setShopCode}
                      textCol={6}
                      inputCol={6}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.JdaLocation",
                      })}
                      type="text"
                      value={jdaLocation}
                      setValue={setJdaLocation}
                      textCol={5}
                      inputCol={7}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.FromDate",
                      })}
                      type="date"
                      valueRef={fromDate}
                      setValue={setFromDate}
                      textCol={5}
                      inputCol={7}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.ToDate",
                      })}
                      type="date"
                      valueRef={toDate}
                      setValue={setToDate}
                      textCol={5}
                      inputCol={7}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={2} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleReset}
                >
                  {intl.formatMessage({ id: "General.Reset" })}
                </Button>
              </Grid>
              <Grid item md={8}></Grid>
              <Grid item md={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleSearchClick}
                >
                  {intl.formatMessage({ id: "General.Search" })}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <CustomTablePagingInfo
        totalCount={totalCount}
        page={page.current}
        maxPage={maxPage.current}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
      />
      <CustomTable
        columns={columns}
        rows={rows}
        id={"tkDashboardId"}
        rowHeight={70}
        headerHeight={80}
        tableHeight={tableHeigth}
      />
    </Box>
  );
};

export default TKDashboard;
